import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '../../../lib/utils';
import type { EmailMentionableUser } from '../useData';
import {
  mentionBadgeClassName,
  mentionBadgeToneForSegment,
  parseMentionSegments,
} from '../utils/mentionUtils';

interface CollaborationNoteBodyProps {
  body: string;
  users: EmailMentionableUser[];
  className?: string;
}

const CollaborationNoteBody: React.FC<CollaborationNoteBodyProps> = ({ body, users, className }) => {
  const segments = parseMentionSegments(body, users);

  return (
    <p className={cn('text-sm whitespace-pre-wrap mt-1', className)}>
      {segments.map((segment, index) => {
        if (segment.type === 'text') {
          return <React.Fragment key={index}>{segment.text}</React.Fragment>;
        }

        const badgeClass = cn(
          'inline rounded px-1.5 py-0.5 text-xs font-semibold align-baseline',
          mentionBadgeClassName(mentionBadgeToneForSegment(segment)),
        );

        if (segment.userId != null) {
          return (
            <Link
              key={index}
              to={`/admin/users/${segment.userId}`}
              className={cn(badgeClass, 'hover:opacity-90 no-underline')}
            >
              @{segment.label}
            </Link>
          );
        }

        return (
          <span key={index} className={badgeClass}>
            @{segment.label}
          </span>
        );
      })}
    </p>
  );
};

export default CollaborationNoteBody;
